import React from 'react';
import { compose, lifecycle, withState } from 'recompose';
import { SelectBox } from 'components/core/Form';
import { addDays, isSameDay, format, startOfDay } from 'date-fns';

import './UnitDropdownDatepicker.scss';

const DEFAULT_OPTION = {
	display: 'Select a date',
	disabled: true,
	value: '',
};

export const enhance = compose(
	withState('options', 'setOptions', []),
	lifecycle({
		componentDidMount() {
			const { reservationWindow, closures } = this.props;
			const today = new Date();
			const dates = Array.from(
				{ length: reservationWindow + 1 },
				(_, k) => addDays(startOfDay(today), k),
			);

			const dateOptions = dates.map((d) => ({
				value: format(d, 'MM/DD/YYYY'),
				disabled: closures.some((c) => isSameDay(c, d)),
				display: format(d, 'dddd, MMMM Do'),
			}));

			const optionsWithDividers = dateOptions.reduce(
				(acc, option, index) => {
					const isSunday = format(option.value, 'dddd') === 'Sunday';
					if (isSunday && index !== 0) {
						acc.push({
							value: `divider-${index}`,
							display: '---------',
							disabled: true,
						});
					}
					acc.push(option);
					return acc;
				},
				[],
			);

			const finalOptions = [DEFAULT_OPTION, ...optionsWithDividers];

			this.props.setOptions(finalOptions);
		},
	}),
);

export function UnitDropdownDatepicker({ ...props }) {
	return (
		<>
			{props.label && (
				<span className="ss-label-text ss-type">{props.label}</span>
			)}
			<SelectBox
				id="unit-reservation-date-dropdown"
				className="dropdown-datepicker"
				errorMessage={props.errorMessage}
				{...props}
			/>
			{props.helpText && (
				<p className="help-text-datepicker ss-type">{props.helpText}</p>
			)}
		</>
	);
}

UnitDropdownDatepicker.propTypes = {
	...SelectBox.propTypes,
};

export default enhance(UnitDropdownDatepicker);
